"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = exports.Note = exports.BoxHead = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const mux_video_react_1 = __importDefault(require("@mux/mux-video-react"));
const polished_1 = require("polished");
exports.BoxHead = styled_components_1.default.div `
	padding: 1em 2em;
	text-align: center;
	background: ${props => (0, polished_1.transparentize)(0.8, props.theme.color.success)};
	border-radius: 4px;
	font-weight: 400;
	font-size: 1.3em;
	strong {
		font-weight: 700;
	}
`;
exports.Note = styled_components_1.default.div `
	width: 100%;
	font-weight: 400;
	font-size: 0.9em;
	padding: 1em 3em 0;
	color: ${props => props.theme.color.gray6};
`;
exports.Video = (0, styled_components_1.default)(mux_video_react_1.default) `
	display: block;
	height: 100%;
	max-width: 100%;
	width: 40em;
	margin: 2em auto;
	border-radius: 0.2rem;
`;
